const { Configuration, OpenAIApi } = require('openai')

const configuration = new Configuration({
  apiKey: "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"
})
const openai = new OpenAIApi(configuration)

module.exports = openai